import { useParams } from 'react-router';
import { useDataRequest } from '@vivli/features/data-requests/infrastructure/hook';
import { LoadIndicatorCenteredView } from '@vivli/shared/views';
import { useEffect } from 'react';
import { DataRequestViewComponent } from './data-request-view.component';
import { useOrganizations } from '@vivli/features/organizations/infrastructure/hook';
import { useDataRequestPermissionsContext } from '@vivli/core/infrastructure/context';

export const DataRequestPrintViewRenderComponent = () => {
    const { dataRequestId, includeRiskScore } = useParams();
    const { dataRequest } = useDataRequest(dataRequestId);
    const { organizations } = useOrganizations();
    const { shouldHideReviewers } = useDataRequestPermissionsContext();

    useEffect(() => {
        document.body.style.height = 'initial';
    }, []);

    if (!dataRequest || !organizations) {
        return <LoadIndicatorCenteredView />;
    }
    return (
        <DataRequestViewComponent
            onReady={() => {
                window.print();
                window.close();
            }}
            dataRequest={dataRequest as any}
            hideReviewers={shouldHideReviewers(dataRequest, organizations, true)}
            isPrintModal={true}
            includeRiskScore={JSON.parse(includeRiskScore)}
            showAimlQuestions={true}
        />
    );
};
